if (typeof window.SectionFeaturedCollection === 'undefined') {
  class SectionFeaturedCollection {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
      this.splideInstance = undefined;
      this.init();
    }

    init() {
      if (!this.splideContainer || typeof window.Splide === 'undefined') return;
      this.enableSplide();
    }

    enableSplide() {
      if (!this.splideInstance) {
        this.splideInstance = new window.Splide(this.splideContainer, {
          type: 'slide',
          autoWidth: true,
          gap: '1rem',
          pagination: false,
          arrows: false,
          duration: 1500,
          dragMinThreshold: 5,
          flickPower: 100,
          mediaQuery: 'min',
          speed: 500,
          easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
          breakpoints: {
            1024: {
              destroy: true,
            },
          }
        }).mount();
      }
    }
  }
  window.SectionFeaturedCollection = SectionFeaturedCollection;
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-featured-collection-splide').forEach(function(splide) {
    new window.SectionFeaturedCollection(splide);
  });
});
